// @ts-check

/**
 * Removes one query parameter and leaves the rest of the search string intact.
 * Returns a value with a leading '?' (or '' when nothing is left) so it can be
 * handed straight to history.push/replace as `search`.
 *
 * Rebuilding through URLSearchParams re-encodes the surviving params, which is
 * deliberate: reassembling the string by hand is what corrupts values containing
 * '&' elsewhere in the app.
 *
 * @param {string} search location.search, with or without the leading '?'
 * @param {string} param name of the parameter to drop
 * @returns {string}
 */
export const removeQueryParam = (search, param) => {
  const params = new URLSearchParams(search);
  params.delete(param);
  const remaining = params.toString();
  return remaining ? `?${remaining}` : '';
};
